import { render, staticRenderFns } from "./ButtonsGroup.vue?vue&type=template&id=60f7f2a1"
import script from "./buttonsGroup.ts?vue&type=script&lang=ts&external"
export * from "./buttonsGroup.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports